// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3VJyj","title":"ClientReferral_title__3zd5-","itemText":"ClientReferral_itemText__nhUjk"};